import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function PopulateMark(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 22 24.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.0887" cy="9.39143" r="1.0301" fill="currentColor" />
      <circle cx="20.7254" cy="6.81721" r="1.0301" fill="currentColor" />
      <circle cx="20.7254" cy="17.6336" r="1.0301" fill="currentColor" />
      <circle cx="1.15022" cy="17.6336" r="1.0301" fill="currentColor" />
      <circle cx="10.9383" cy="23.2977" r="1.0301" fill="currentColor" />
      <circle cx="10.9373" cy="1.15119" r="1.0301" fill="currentColor" />
      <circle cx="1.15022" cy="6.81721" r="1.0301" fill="currentColor" />
      <path
        d="M1.15039 17.632L16.089 9.39119M1.15039 17.632L10.9377 23.2976M1.15039 17.632V6.81594M16.089 9.39119L20.7251 6.81594M16.089 9.39119L20.7251 17.632M16.089 9.39119L10.9377 23.2976M16.089 9.39119L10.9377 1.15039M16.089 9.39119L1.15039 6.81594M20.7251 6.81594V17.632M20.7251 6.81594L10.9377 1.15039M20.7251 17.632L10.9377 23.2976M1.15039 6.81594L10.9377 1.15039"
        stroke="currentColor"
        strokeWidth="0.360535"
      />
    </SvgIcon>
  );
}
